import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EmailService {
    /**
     * This map contains corrections for common typos in email addresses.
     */
    private readonly domainCorrections: { [key: string]: string } = {
        "gmil.com": "gmail.com",
        "gmail.con": "gmail.com",
        "gmail.co": "gmail.com",
        "gmal.com": "gmail.com",
        "buewin.ch": "bluewin.ch",
        "bluwin.ch": "bluewin.ch",
        "mail.dd": "mail.de",
        "t.online.de": "t-online.de",
        "t-online.dr": "t-online.de",
        "t-onlinr.de": "t-online.de",
        "hotmil.com": "hotmail.com",
        "hormail.de": "hotmail.de"
    };

    /**
     * Corrects common typos in email addresses.
     *
     * @param email The email address to correct.
     * @returns The corrected email address.
     */
    correctEmailAddress(email: string): string {
        if (!email || (typeof email !== "string")) {
          // stop if email is empty or does not exist
          return email;
        }
        const [localPart, domain] = email.split('@');
        const correctedDomain = this.domainCorrections[domain] || domain;
        return `${localPart}@${correctedDomain}`;
    }
}
